export enum RegexTableSectionsEnum {
  characters = 'Characters',
  quantifiers = 'Quantifiers',
  characterClasses = 'Character Classes',
  anchorsAndBoundaries = 'Anchors & Boundaries',
  groupsAndBackreferences = 'Groups & Backreferences',
  greedyVsNonGreedyQuantifiers = 'Greedy vs. Non-Greedy Quantifiers',
  inlineModifiers = 'Inline Modifiers',
}
